// /green-shield — Dream Life Lawn · Founder Node
// Thin wrapper. All 6-module chassis logic lives in
// /components/VerticalCockpit.jsx. Copy from verticalConfig.js.
// Skin from PALETTES.LAWN in AssetSpine.js.
import VerticalCockpit from "@/components/VerticalCockpit";
import { PALETTES } from "@/config/AssetSpine";
import { VERTICAL_CONFIG } from "@/config/verticalConfig";

export default function GreenShield() {
  return (
    <VerticalCockpit
      config={VERTICAL_CONFIG.LAWN}
      palette={PALETTES.LAWN}
      testPrefix="gs"
    />
  );
}
